<template>
  <v-container class="mt-2 mr-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title >
            Historial

            <v-spacer></v-spacer>

            <v-btn  class="orange ml-2" small tile dark @click="initialize" ><v-icon>mdi-refresh</v-icon> </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="8" lg="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar Usuarios"
                  filled
                  dense
                  single-line
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tabla -->
            <v-data-table
              :headers="headers"
              :items="historial"
              dense
              fixed-header
              loading-text="Cargando..."
              dense
              :search="search"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  color="secondary"
                  small
                  class="mr-2"
                  @click="download(item)"
                >
                  mdi-download
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      scrollable  
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <v-btn color="primary" @click="descargar()">Descargar</v-btn>
        </v-card-title>
        <embed :src="`https://support-smipack.com/viewer/web/viewer.html?file=`+pdf" width="100%" :height="tamanioDisplay - 130">
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'


  export default {
    data: () => ({
      filename:'',
      pdf:'',
      url:'https://support-smipack.com/pdf/',
    	longitud:5,
    	search:'',
      dialog: false,
      headers: [
        { text: 'Id', align: 'start', sortable: false, value: 'idhistorialcoti'},
        { text: 'Folio',     value: 'nomdocum' },
        { text: 'Usuario',    value: 'nomuser' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Nota', value: 'nota' },
        { text: 'Actions',  value: 'actions', sortable: false, align: 'center', },
      ],
      historial: [],
    }),

    computed: {
      tamanioDisplay () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return this.$vuetify.breakpoint.height
          break;
          case 'sm': 
            return this.$vuetify.breakpoint.height
          break;
          case 'md':
            return this.$vuetify.breakpoint.height
          break;
          case 'lg':
            return this.$vuetify.breakpoint.height 
          break;
          case 'xl':
            return this.$vuetify.breakpoint.height
          break;
        }
      },
      
    },

    watch: {
      
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.historial = []
        this.$http.get('historial.all').then(response=>{
          this.historial = response.body
          for(const i in this.historial){
            this.historial[i].fecha  = this.historial[i].fecha.substr(0,10)
          }
          this.longitud = this.historial.length
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      download(item){
        this.filename = ''
        this.filename = item.nomdocum
        this.pdf = ''
        this.pdf = this.url + item.nomdocum + '.pdf'
        this.dialog = true
        console.log(item)
      },

      descargar(){
        // FileSaver.saveAs(new Blob([this.s2ab(wbout)],{type:"application/octet-stream"}), this.filename  + '.xlsx');
        window.open(this.$http.options.root + 'pdfs/' + this.filename + '.pdf')
      }

    },
  }
</script>